<div class="supp-code-div">
  @if (params.data.linkAcc) {
    <span>
      <span
        [matTooltip]="'Linked To' + params.data.linkAcc"
        class="mdi mdi-link-variant">
      </span>
    </span>
  }
  @if (onHoldDecode(params.data.onHoldCode, {isSupplier: false, returnCodes: true}) !== null &&
  onHoldDecode(params.data.onHoldCode, {isSupplier: false, returnCodes: true}).length > 0) {
    <span
    >
      <span
        [matTooltip]="'On Hold For: ' + getOnHoldCodeArray(params.data.onHoldCode)"
        class="mdi mdi-lock-outline">
      </span>
    </span>
  }
</div>
